import ScreeningForGuarantors from "./ScreeningForGuarantors";

export default ScreeningForGuarantors;
